import Expandable from "../../generic-building-blocks/Expandable";
import NotificationPreview from "../editFormReboot/NotificationPreview";
import SignalFormatInput from "../editFormReboot/SignalFormatInput";
import { MetricMeta, MetricMetaKeys } from "@avenueops/shared-types";
import { NotificationType, WorkflowTriggerType } from "@prisma/client";
import { useQueryColumns, useEnrichmentColumns, useQueryRunResults } from "context/QueryRunContext";
import _ from "lodash";
import { useFormContext } from "react-hook-form";

interface Props {
  control: any;
  notificationPrefix: string;
  notificationType: NotificationType;
  includeTitle?: boolean;
  useMarkdown?: boolean;
}

export default function CustomSubscriberSignalFormat({
  control,
  notificationPrefix,
  notificationType,
  includeTitle = true,
  useMarkdown = true,
}: Props): JSX.Element {
  const typeText = _.capitalize(notificationType);

  const { watch, setValue } = useFormContext();
  const workflowType = watch("workflowType");
  const messageFormat = watch(`${notificationPrefix}.messageFormat`);
  const workflowTriggerType = watch("workflowTriggerType");

  const { queryRunResults } = useQueryRunResults();
  const queryColumns = useQueryColumns();
  const enrichmentColumns = useEnrichmentColumns();
  const formatOptions = workflowType === "METRIC" ? MetricMetaKeys : [...queryColumns, ...enrichmentColumns];

  return (
    <Expandable
      title={<span className="font-semibold text-sm">Customize Signal Formatting</span>}
      tooltipText={`Overwrite the signal title and body only for ${typeText} notifications`}
    >
      <div className="border border-1 p-5">
        <SignalFormatInput
          control={control}
          titleFormatConfig={{ name: `${notificationPrefix}.titleFormat`, includeTitle: includeTitle }}
          messageFormatConfig={{ name: `${notificationPrefix}.messageFormat`, useMarkdown: useMarkdown }}
          formatOptions={formatOptions}
        />
      </div>
    </Expandable>
  );
}
